import { axiosInstanceV2 } from "./AxiosInstance";

const API_URL = "/appstoroles";

export const getappstoroles = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)

    // Check if response structure matches what you expect
    if (!response.data || !response.data.data) {
      throw new Error("Invalid response structure from server");
    }

    return {
      data: response.data.data,
      pagination: response.data.pagination || {
        total: response.data.data.length,
        page: page,
        limit: limit
      },
    };
  } catch (error) {
    console.error("Error fetching appstoroles", {
      url: API_URL,
      params: { limit, page, search, searchField },
      status: error.response?.status,
      code: error.response?.data?.message?.code,
      message: error.response?.data?.message?.message || error.message,
      responseData: error.response?.data
    });

    // Create a custom error object with more details
    const customError = new Error(error.response?.data?.message?.message || "Failed to fetch appstoroles");
    customError.code = error.response?.data?.message?.code || "UNKNOWN";
    customError.status = error.response?.status;
    customError.responseData = error.response?.data;
    
    throw customError;
  }
};

export const createappstoroles = async (moduleData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, moduleData);
    
    if (response.data?.isError) {
      throw new Error(response.data.message?.message || "Creation failed");
    }

    return response.data;
  } catch (error) {
    console.error("Error creating appstoroles", {
      url: API_URL,
      requestData: moduleData,
      status: error.response?.status,
      errorDetails: error.response?.data,
      fullError: error
    });

    const customError = new Error(error.response?.data?.message?.message || "Failed to create appstoroles");
    customError.code = error.response?.data?.message?.code || "CREATE_FAILED";
    throw customError;
  }
};

// Similar improvements for other CRUD operations
export const updateappstoroles = async (moduleId, moduleData) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${moduleId}`, moduleData);
    
    if (response.data?.isError) {
      throw new Error(response.data.message?.message || "Update failed");
    }

    return response.data;
  } catch (error) {
    console.error("Error updating appstoroles", {
      url: `${API_URL}/${moduleId}`,
      requestData: moduleData,
      status: error.response?.status,
      errorDetails: error.response?.data
    });

    const customError = new Error(error.response?.data?.message?.message || "Failed to update appstoroles");
    customError.code = error.response?.data?.message?.code || "UPDATE_FAILED";
    throw customError;
  }
};

export const deleteappstoroles = async (moduleId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${moduleId}`);
    
    if (response.data?.isError) {
      throw new Error(response.data.message?.message || "Deletion failed");
    }

    return response.data;
  } catch (error) {
    console.error("Error deleting appstoroles", {
      url: `${API_URL}/${moduleId}`,
      status: error.response?.status,
      errorDetails: error.response?.data
    });

    const customError = new Error(error.response?.data?.message?.message || "Failed to delete appstoroles");
    customError.code = error.response?.data?.message?.code || "DELETE_FAILED";
    throw customError;
  }
};

export const getappstorolesById = async (moduleId) => {
  try {
    const response = await axiosInstanceV2.get(`${API_URL}/${moduleId}`);
    
    if (!response.data || !response.data.data) {
      throw new Error("Invalid response structure");
    }

    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message || "Success",
    };
  } catch (error) {
    console.error("Error fetching appstoroles details", {
      url: `${API_URL}/${moduleId}`,
      status: error.response?.status,
      errorDetails: error.response?.data
    });

    const customError = new Error(error.response?.data?.message?.message || "Failed to fetch appstoroles details");
    customError.code = error.response?.data?.message?.code || "FETCH_DETAILS_FAILED";
    throw customError;
  }
};
